import React, { useState } from 'react'

import LoginFormContainer from '../login/LoginFormContainer'
import ModalPopup from '../common/ModalPopup'
import NavSubDaily from './NavSubDaily'
import data from '../../data/appData'
import { NavBar } from '@foodsby/nutrient'
import { ProfileAvatar } from '../profile/ProfilePicture'
import { ROLE_FOODSBY_ADMIN } from '../../redux/modules/user'
import { ThemeProvider } from 'styled-components'
import { changeSelectedDay } from '../../redux/modules/home'
import { clearFriendsAtDateTime } from '../../redux/modules/friends'
import { connect } from 'react-redux'
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days'
import { formatUrl } from '../../util/formatUtils'
import { locationRoute } from '../../routes/routes'
import { safeDifferenceInDays } from '../../util/locationUtils'
import {
  isSelectedDeliveryDateActive,
  selectIsAuthenticated,
} from '../../redux/modules/selectors'

const FOODSBY_ONE_AUTHORITIES = [
  'ROLE_ACCOUNTS_READ',
  'ROLE_FOODSBY_ACCOUNTS_READ',
]
const isAdmin = (authorities = []) => authorities.includes(ROLE_FOODSBY_ADMIN)
const isFoodsbyOne = authorities =>
  authorities &&
  authorities.some(auth => FOODSBY_ONE_AUTHORITIES.includes(auth))

const ProfileImage = ({ avatarId, name, isWebpSupported }) => {
  const imgSrc =
    avatarId &&
    `${process.env.REACT_APP_IMAGE_LAMBDA}/profiles/${avatarId}.${
      isWebpSupported ? 'webp' : 'jpg'
    }?height=50&width=50`

  return (
    <ProfileAvatar
      className="profile-image_header--flyout"
      name={name}
      size={20}
      src={imgSrc}
    />
  )
}

// Temp hack till we fix the Icons in Nutrient
const theme = {
  glyphs: {
    daily: { content: "'\\0046'" },
    facebook: { content: "'\\0041'" },
    hamburger: { content: "'\\0042'" },
    instagram: { content: "'\\0043'" },
    linkedin: { content: "'\\0044'" },
    meetings: { content: "'\\0045'" },
    twitter: { content: "'\\0047'" },
  },
}

const Header = ({
  activationDate,
  avatarId,
  changeSelectedDay,
  clearFriendsAtDateTime,
  currentUser,
  friendsAtOrderDelivered,
  history,
  isAuthenticated,
  isSelectedDayActive,
  isWebpSupported,
  locationId,
  profileStatus,
  selectedDate,
  showSubNav,
  todaysDate,
}) => {
  const home = formatUrl(locationRoute.path, { locationId: locationId })
  const isHome = window.location.pathname === home
  const [loginOrJoin, setLoginOrJoin] = useState(false)
  let hideLoginButton = false

  if (window.location.pathname === '/login') {
    hideLoginButton = true
  }
  // Let's clean this up, we could pass profile as prop and solve the admin
  let flyoutLinks =
    profileStatus !== 'CONFIRMED'
      ? [...data.simpleMenu]
      : [
          {
            ...data.headerMenu[0],
            copy: (
              <>
                <ProfileImage
                  avatarId={avatarId}
                  isWebpSupported={isWebpSupported}
                />{' '}
                {data.headerMenu[0].copy}
              </>
            ),
          },
          ...data.headerMenu.slice(1),
        ]
  if (isAuthenticated) {
    if (isAdmin(currentUser.authorities)) {
      flyoutLinks = [...flyoutLinks, ...data.adminMenu]
    }
    if (isFoodsbyOne(currentUser.authorities)) {
      flyoutLinks = [...flyoutLinks, ...data.foodsbyOne]
    }
    flyoutLinks = [...flyoutLinks, ...data.logout]
  }
  return (
    <ThemeProvider theme={theme}>
      <header style={{ zIndex: 4, position: 'relative' }}>
        <NavBar
          dailyLink={process.env.REACT_APP_FOODSBY_BASE_URL}
          flyoutLinks={flyoutLinks}
          hideLoginButton={hideLoginButton}
          home={`${process.env.REACT_APP_FOODSBY_BASE_URL}/main`}
          isAuthenticated={isAuthenticated}
          isDailySelected={true}
          loginOnClick={() => {
            setLoginOrJoin(true)
          }}
          meetingsLink={process.env.REACT_APP_GROUP_ORDER_URL}
        ></NavBar>
      </header>
      {showSubNav &&
        (isSelectedDayActive ||
          differenceInCalendarDays(activationDate, new Date()) < 6) && (
          <NavSubDaily
            activationDate={activationDate}
            className="sticky"
            daysUntilActive={safeDifferenceInDays(activationDate)}
            locationId={locationId}
            onChangeDay={date => {
              changeSelectedDay(date, locationId)
              if (!isHome) {
                history.push(home)
              }
            }}
            selectedDate={selectedDate}
            todaysDate={todaysDate}
          />
        )}
      {loginOrJoin && (
        <>
          <ModalPopup
            onCancel={() => {
              setLoginOrJoin(false)
            }}
            showCancel={true}
          >
            <>
              <h2
                className="title"
                style={{ marginBottom: '16px', textAlign: 'center' }}
              >
                Login
              </h2>
              <LoginFormContainer
                joinTitle="Register"
                locationId={locationId}
                loginMessage="Login and get lunch to your office."
                loginTitle="Login"
                path={window.location.pathname}
                signupMessage="Sign up and get lunch to your office."
              />
            </>
          </ModalPopup>
        </>
      )}
    </ThemeProvider>
  )
}

function mapStateToProps(state) {
  const { location: { activationDate } = {} } = state.location
  const isSelectedDayActive = isSelectedDeliveryDateActive(state)
  const isAuthenticated = selectIsAuthenticated(state)
  const { todaysDate, selectedDate } = state.home
  const { friendsAtOrderDelivered } = state.friends
  const { isWebpSupported } = state.browser
  return {
    isSelectedDayActive,
    activationDate,
    todaysDate,
    isAuthenticated,
    selectedDate,
    friendsAtOrderDelivered,
    isWebpSupported,
  }
}

const mapDispatchToProps = {
  changeSelectedDay,
  clearFriendsAtDateTime,
}

Header.defaultProps = {
  menuItems: [],
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
